import { Controller } from "@hotwired/stimulus"

// Shows a field only when a source control has one of the values it lists, e.g.
// data-show-when="coverage:federal,statewide" with a source named "coverage". Hidden fields are
// disabled so they neither submit nor block validation; the server still normalizes the result.
// Selects with <optgroup data-state="…"> keep only the group for the chosen "state" source.
// Connects to data-controller="conditional-fields"
export default class extends Controller {
  static targets = ["source", "field"]

  connect() {
    this.collectGroups()
    this.update()
  }

  // A morph restores the server-rendered options; filter them again.
  morphed(event) {
    if (event.target !== this.element) return
    this.collectGroups()
    this.update()
  }

  collectGroups() {
    this.groups = new Map()
    this.element.querySelectorAll("select").forEach((select) => {
      const groups = [...select.querySelectorAll("optgroup[data-state]")]
      if (groups.length) this.groups.set(select, groups)
    })
  }

  update() {
    const values = {}
    this.sourceTargets.forEach((source) => {
      if (source.type === "radio" && !source.checked) return
      values[source.dataset.sourceName] = source.value
    })

    this.fieldTargets.forEach((field) => {
      const [name, allowed] = field.dataset.showWhen.split(":")
      const visible = allowed.split(",").includes(values[name])
      field.hidden = !visible
      field.querySelectorAll("input, select, textarea").forEach((control) => { control.disabled = !visible })
    })

    this.groups.forEach((groups, select) => {
      const current = select.value
      groups.forEach((group) => group.remove())
      const match = groups.find((group) => group.dataset.state === values.state)
      if (match) select.append(match)
      // Clear a choice that no longer applies, such as a race in another state.
      select.value = [...select.options].some((option) => option.value === current) ? current : ""
    })
  }
}
